import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect, useRef} from 'react';

const HeaderButton = (props) => {
  function Navigate() {
    props.context.navigateTo(props.headerButtonLink.value);
  }

  var designModeNumber = -1;
  var designText = 'להצטרפות';

  if (props.blockButton.value!=null) {
    designText = (props.blockButton.expandedValue[0] as any).text.value;
    designModeNumber = (props.blockButton.expandedValue[0] as any).buttonDesignMode.value;
  }

  const getButtonClassByName = (designIndex) => {
    let name = '';
    switch (designIndex) {
      case 0:
        name = 'purple-button';
        break;
      case 1:
        name = 'black-button';
        break;
      case 2:
        name = 'white-button';
        break;
      case -1:
        name = 'HeaderButton__button-container__button';
        break;
    }
  
    return name;
  };

  return (
    
    <>
      <div className='HeaderButton'>
        <div className='HeaderButton__button-container'>
          <a className={`HeaderButton__button-container__button ${getButtonClassByName(designModeNumber)}`} href='#' onClick={Navigate} > {designText}
            <Image src={require('./images/icons.svg')} />  
          </a>
        </div>
      </div>
    </>
    
  );
  
};

export default HeaderButton;
